import * as React from "react";
import { withStyles } from "@material-ui/core";
import { DevelopmentStore } from "modules/development/DevelopmentStore";

import { BrowserRouter } from "react-router-dom";

import { WBSStore } from "modules/WBS/WBSStore";
import { WBSService } from "modules/WBS/WBSService";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { LoginStore } from "modules/login/LoginStore";
import WBSComponent from "modules/WBS/components/pages/WBS";
import TaskLayer from "modules/WBS/components/pages/TaskLayer";
import Header from "modules/costPlan/components/layouts/Header";
import ArrowBreadCrumb from "common/components/ArrowBreadCrumb";
import DialogItemOccurrences from "modules/WBS/components/layouts/DialogItemOccurrences";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";

const styles = (theme) => ({
  grid: {
    display: "grid",
    gridTemplateRows: "30px 1fr 30px",
  },
  breadCrumbBar: {
    backgroundColor: "#FFFFFF",
    border: ".5px solid #cccccc",
    overflow: "hidden",
  },
});

type IProps = {
  classes: any;
  match?: any;
};

class CostPlan extends React.Component<IProps> {
  state = {
    loaded: false,
  };

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    WBSStore.loading = true;
    if (WBSStore.WBS.id && WBSStore.dataTable.length > 0) {
      this.setState({ loaded: true });
      WBSStore.loading = false;
    } else this.getWBSById();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.url !== nextProps.match.url) this.getWBSById();
  }

  getWBSById = async () => {
    WBSService.projectUpdate();
    WBSStore.ouvinte();
    this.setState({ loaded: true });
  };
  handleClickRootArrowBreadCrumb() {
    ToolbarTaskStore.resetStore();
    setTimeout(() => {
      WBSStore.setSelectedLine(WBSStore.getLineIndex, "description", false);
    }, 1);
  }

  render() {
    const development = DevelopmentStore.developmentSelected;
    const {
        props: { classes },
        state: { loaded },
      } = this,
      { WBS } = WBSStore;
    let url;
    let heightGrid = LoginStore.isTrialUser()
      ? { height: "calc(100vh - 70px)" }
      : { height: "calc(100vh - 33px)" };
    if (loaded) url = `/${development.id}/WBS`;

    return (
      <div>
        {loaded && (
          <BrowserRouter>
            <div className={classes.grid} style={heightGrid}>
              <Header
                name={WBSStore.wbsName}
                development={WBS.data.development}
                developmentName={development.data.name}
              />
              <div style={{ position: "relative", overflow: "hidden" }}>
                <WBSComponent url={url} />
                <TaskLayer />
                <DialogItemOccurrences />
              </div>
              <div style={{ overflowY: "scroll" }}>
                <ArrowBreadCrumb
                  root={{
                    url,
                    text: "Principal",
                    onClick: () => this.handleClickRootArrowBreadCrumb(),
                  }}
                  pathPromisesArray={WBSStore.paths}
                  getText={{
                    func: (id) => WBSStore.findWBSRowById(id),
                    response: (item) => item.data.description,
                  }}
                  breadItemPromise={(index, last, item) => {
                    if (last && item.data) {
                      ToolbarStore.WBSCopiedLine = undefined;
                      ToolbarStore.WBSCuttedLine = undefined;
                      WBSStore.setSelectedTask(item.data);
                    }
                  }}
                  noLinksEvent={() => {
                    ToolbarStore.WBSCopiedLine = undefined;
                    ToolbarStore.WBSCuttedLine = undefined;
                    WBSStore.task = false;
                    WBSStore.taskRows = [];
                  }}
                />
              </div>
            </div>
          </BrowserRouter>
        )}
      </div>
    );
  }
}
export default withStyles(styles)(CostPlan);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/pages/CostPlan.tsx